import React, { useEffect, useState } from 'react';
import { navigatePage } from '@cap/share/src/utils/navigation/index';
import { useHistory } from 'react-router-dom';
import useRouteParams from '@cap/share/src/hooks/useRouteParams';
import { useQueryParams } from '@cap/rzmt-core';
import Tag from './components/Tag';
import SearchBar from '@/components/SearchBar';
import UserName from './components/UserName';
import { POT_MENU_BAR } from '@/utils/const';

import './index.less';
import { FINISH_HEIGHT, MAX_OPACITY, MAX_SEARCH_BG_NUM, MIN_OPACITY, MIN_SEARCH_BG_NUM } from './const';

const Head: React.FC = () => {
  const [opacity, setOpacity] = useState(MIN_OPACITY);
  const [searchBgNum, setSearchBgNum] = useState(MAX_SEARCH_BG_NUM);

  const history = useHistory(); // 用 useHistory 代替 useNavigate
  const { pathname } = useRouteParams();

  const imageUrl =
    'https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:86dee248/%E7%BE%8E%E5%9B%A2%E5%9F%B9%E8%AE%ADlogo.png';

  // 处理从搜索框组件传递过来的keyword
  const keywordChange = (eventData: string, placeholder: string): void => {
    if (POT_MENU_BAR.findIndex((c) => c.value === pathname) === -1) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set('key', eventData); // 设置key为eventData
      history.push(`${pathname}?${searchParams.toString()}`); // 使用 history.push 更新URL
      if (pathname !== '/web/search-courses')
        navigatePage('/web/search-courses', { query: { key: eventData || placeholder }, windowOpen: true });
    } else {
      navigatePage('/web/search-courses', { query: { key: eventData || placeholder }, windowOpen: true });
    }
  };
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    if (scrollTop < 2) {
      setOpacity(MIN_OPACITY);
      setSearchBgNum(MAX_SEARCH_BG_NUM);
    } else if (scrollTop < FINISH_HEIGHT) {
      setOpacity(parseFloat(((scrollTop * MAX_OPACITY) / FINISH_HEIGHT).toFixed(4)));
      setSearchBgNum(
        parseFloat(
          (MAX_SEARCH_BG_NUM - ((MAX_SEARCH_BG_NUM - MIN_SEARCH_BG_NUM) * scrollTop) / FINISH_HEIGHT).toFixed(4),
        ),
      );
    } else {
      setOpacity(MAX_OPACITY);
      setSearchBgNum(MIN_SEARCH_BG_NUM);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const isFromNewHome = useQueryParams('isFromNewHome');
  const showTitleBar = () => {
    const courseValues = ['/article', '/video'];
    const courseDetailsPage = courseValues.some((value) => pathname.includes(value));
    if (!courseDetailsPage) return true;
    if (isFromNewHome === 'true') return true;
    return false;
  };

  const goToHome = () => {
    // 仅从主站进入才能点击logo返回首页
    if (showTitleBar()) {
      navigatePage('/web');
    }
  };

  return (
    <div className="head-wrap" style={{ backgroundColor: `rgba(255, 255, 255, ${opacity})` }}>
      <div className="head-content">
        <div className="head-left">
          <img className="head-mt-img" src={imageUrl} alt="Peixun Logo" onClick={goToHome} />
          {showTitleBar() && <Tag />}
        </div>

        <div className="head-right">
          <SearchBar keywordChange={keywordChange} bgNum={searchBgNum} />
          <UserName />
        </div>
      </div>
    </div>
  );
};

export default Head;
